// Libs
import React, { useContext } from 'react';
// Components
import { Span } from 'components';
// Context
import { ElementViewBuilderContext } from 'core/context';
// Config
import { ElementViewBuilderConfig } from 'core/ElementViewBuilder';

export const hasOrders = value => Number(value) > 0;

export const ROOT_ORDER_FLOW_TYPES = Object.freeze([
	'orders_total',
	'orders_topay',
	'orders_notpay',
	'orders_previous',
	'orders_pending',
	'orders_paid',
]);

export const isRootOrderFlowType = orderFlowType =>
	ROOT_ORDER_FLOW_TYPES.includes(orderFlowType);

const OrdersOverview = ({
	field,
	elementId,
	name,
	value,
	disableOverview,
	coin_id,
	paid_to,
	paycut_id,
	isPaymentSigned,
	isPaymentOpen,
	orderFlowType,
}) => {
	const { setElementView } = useContext(ElementViewBuilderContext);
	const elementViewKeys =
		ElementViewBuilderConfig.getAuthorizedElementViewKeys();
	const canOpen =
		hasOrders(value) &&
		!disableOverview &&
		(typeof field.onClick === 'function' || isRootOrderFlowType(orderFlowType));

	const handleOpenOverview = e => {
		if (!canOpen) return;

		const overviewPayload = {
			elementId,
			name,
			coin_id,
			isPaymentSigned,
			isPaymentOpen,
			...(orderFlowType === 'orders_paid' ? { paycut_id } : {}),
		};

		if (typeof field.onClick === 'function') {
			field.onClick(overviewPayload);
			e.stopPropagation();
			return;
		}

		e.stopPropagation();
		setElementView({
			elementViewKey:
				elementViewKeys.BILLING_PAYMENT_PAYCUT_DETAILS_REQUEST_ELEMENT,
			elementId: paycut_id || elementId,
			paycutId: paycut_id,
			isInvoice: true,
			initialView: {
				tabKey: 'ordersKey',
				ordersOnly: true,
				readOnly: true,
				canManageOrders: false,
				titleTab: name || '',
				fechtData: {
					paymentId: elementId,
					paycutId: paycut_id,
					paid_to,
					orderFlowType,
					headerLabel: name || '',
					paymentCoinId: coin_id,
					isPaymentSigned,
					isPaymentOpen,
				},
			},
		});
	};

	return (
		<Span hoverable={canOpen} onClick={canOpen ? handleOpenOverview : undefined}>
			{value}
		</Span>
	);
};

export default OrdersOverview;
